import { BaseTable, Card, FooterMenu, HeaderMenu, Label, Loading, Select, TableHeader } from "components";
import { Item } from "./components";
import { appDropdown, useApprovalList } from "./utils";
import { useState } from "react";

export default function ApproveBills() {

    const [searchData, setSearchData] = useState<string>('1')
    const { data, isLoading, refetch } = useApprovalList(searchData)

    return (
        <section className="container my-2">
            <section>
                <HeaderMenu title="BILL APPROVAL" />

                <section>
                    <section className="mt-2">
                        <Card>
                            <Card.Body>
                                <div className="justify-end lg:flex items-center">
                                    <Label className="mr-2">APPROVAL</Label>
                                    <Select
                                        className="lg:w-[200px]"
                                        placeholder="Select Approval"
                                        options={appDropdown}
                                        value={appDropdown.find(item => item.value === searchData)}
                                        onChange={e => setSearchData(e?.value ?? '')}
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                    </section>
                </section>

                <section className="mt-2">
                    <Card>
                        <Card.Body>
                            <div className="overflow-x-auto max-h-[calc(100vh-500px)]">
                                <BaseTable>
                                    <TableHeader>
                                        <tr>
                                            <th>No</th>
                                            <th colSpan={2}>BILLS ID#</th>
                                            <th>DATE</th>
                                            <th>VENDOR</th>
                                            <th>REF PO ID#</th>
                                            <th>DELIVERY</th>
                                            <th>LOCATION</th>
                                            <th>MEMO</th>
                                            <th>APPROVAL STATUS</th>
                                            <th>APPROVAL DATE</th>
                                        </tr>
                                    </TableHeader>
                                    <tbody>
                                        {isLoading || data?.length === 0 ? (
                                            <tr>
                                                <td colSpan={12} className="text-center">
                                                    <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                                                </td>
                                            </tr>)
                                            : data?.map((item, key: number) => (
                                                <Item data={item} index={key} refetch={refetch} />
                                            ))}
                                    </tbody>
                                </BaseTable>
                            </div>
                        </Card.Body>
                    </Card>
                </section>

                <section className="mt-2">
                    <FooterMenu />
                </section>
            </section>
        </section>
    )
}